import { result } from './api/entities';
import actions from './result_actions';

export function resetResultState() {
  return { type: actions.resetResultState };
}

export function startMinutesPlayedFetch() {
  return { type: actions.getPlayerMinutesPlayer };
}

export function startAngleDataFetch() {
  return { type: actions.getPlayerAngleData };
}

export function createResult(resultObject) {
  return result.create(actions.createResult, resultObject, []);
}

export function updateResult(resultId, resultObject) {
  return result.update(actions.updateResult, resultId, resultObject, []);
}

export function getResults(query, sort) {
  return result.list(actions.listResult, query, sort);
}

export function getResult(resultId) {
  return result.get(actions.getResult, resultId, []);
}

const INITIAL_STATE = {
  results: [],
  result: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetResultState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createResult:
      return {
        ...state,
        results: action.body ? [...state.results, action.body] : state.results,
      };
    case actions.listResult:
      return {
        ...state,
        results: action.body ? action.body._items : state.results,
      };
    case actions.getResult:
      return {
        ...state,
        result: action.body ? action.body : state.result,
      };
    case actions.updateResult:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    case actions.getPlayerMinutesPlayer:
      return {
        ...state,
        minutes_played: [],
      };
    case actions.updateMinutesPlayed:
      return {
        ...state,
        minutes_played: action.minutes_played,
      };
    case actions.getPlayerAngleData:
      return {
        ...state,
        angle_data: [],
      };
    case actions.updateAngleData:
      return {
        ...state,
        angle_data: action.angle_data,
      };
    case actions.getPlayerROMData:
      return {
        ...state,
        rom_data: [],
      };
    case actions.updatePlayerROMData:
      return {
        ...state,
        rom_data: action.rom_data,
      };
    default:
      return {
        ...state,
      };
  }
}
